/* eslint-disable no-case-declarations */
export default (state = { open: false, selectedFilterId: null }, action) => {
    switch (action.type) {
        case 'TOGGLE_FILTERS_TANAK':
            const { data: { selectedFilterId = null, open } = {}} = action;

            return {
                open: open === undefined ? !state.open : open,
                selectedFilterId
            };
        default:
            return state;
    }
};
